import React from 'react';
import classNames from 'classnames';
import './FooterPlus.css';

type Props = {
  onClick: (...args: any[]) => any;
  className: string;
};

const FooterPlus = ({ onClick, className }: Props) => (
  <svg
    className={classNames('footer-plus', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    onClick={onClick}
  >
    <path d="M24 9h-9v-9h-6v9h-9v6h9v9h6v-9h9z" />
  </svg>
);

export default FooterPlus;
